export const styles = {
  typography: {
    fontWeight: "800",
    fontSize: "16px",
  },
};
